import classNames from "classnames";
import * as moment from "moment";
import * as React from "react";
import { FormInput } from "source/app/presentation/Shared/Form/Input/FormInput";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { ICalendarEventEditorState } from "../ICalendarEventEditorState";

export function ShowDateTimeLocalInput({
    state,
    setState,
    label,
    isReadOnly,
}: {
    state: ICalendarEventEditorState;
    setState: React.Dispatch<React.SetStateAction<ICalendarEventEditorState>>;
    label: string;
    isReadOnly: boolean;
}) {
    const [initialMoment, setInitialMoment] = React.useState(
        moment(state.calendarEvent[label])
    );

    const [hasValueChanged, setHasValueChanged] =
        React.useState<boolean>(false);

    React.useEffect(() => {
        const currentMoment = moment(state.calendarEvent[label]);
        setHasValueChanged(!initialMoment.isSame(currentMoment));
    }, [state.calendarEvent[label]]);

    const valueChangedStyleClass = StyleClass(
        `showDateTimeCalendarEventValueChanged`,
        {
            color: `gold !important`,
        }
    );

    return (
        <div>
            <FormInput
                id={`calendarEvent_${label}_datetime`}
                label={label}
                width="230px"
                type="datetime-local"
                value={moment(state.calendarEvent[label])
                    .local()
                    .format(`YYYY-MM-DDTHH:mm`)}
                classes={classNames({
                    [valueChangedStyleClass]: hasValueChanged,
                })}
                readonly={isReadOnly}
                onChange={(event) => {
                    setState({
                        ...state,
                        calendarEvent: {
                            ...state.calendarEvent,
                            [label]: moment(event.target.value).format(
                                "YYYY-MM-DDTHH:mm:ssZ"
                            ),
                        },
                    });
                }}
            />
        </div>
    );
}
